import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=00b5525e&scoped=true&"
import script from "./TeacherEdit.vue?vue&type=script&lang=js&"
export * from "./TeacherEdit.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEdit.vue?vue&type=style&index=0&id=00b5525e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b5525e",
  null
  
)

export default component.exports